
<input ref="input" type="file" :accept="file.accept" v-on:change="change" />
